// import { CloseIcon } from 'components/Material/CloseIcon'
import CloseIcon from '@mui/icons-material/Close'
import CheckIcon from '@mui/icons-material/Check'
import PersonOutlineIcon from '@mui/icons-material/PersonOutline'
import cn from 'classnames'
import { Box, Typography } from 'components/Material/index'
import AttachFileIcon from '@mui/icons-material/AttachFile'
import { useNavigate } from 'react-router-dom'
import useTextStyles from 'styles/useTextStyles'
import { BbLogoIcon } from '../IconesSVG'
import MobileFriendlyOutlinedIcon from '@mui/icons-material/MobileFriendlyOutlined'
import ModeEditOutlinedIcon from '@mui/icons-material/ModeEditOutlined'

type SimpleCardProps = {
  title?: string
  subtitle?: string
  icon?: string
  iconContainerBackground?: string
  route?: string
  isSelected?: boolean
}

export const SimpleCard = ({
  title,
  subtitle = '',
  icon,
  route = '',
  iconContainerBackground = '#bbbbbb',
  isSelected = false
}: SimpleCardProps) => {
  const navigate = useNavigate()

  const handleNextStep = () => {
    if (route) navigate(route)
  }

  return (
    <Box
      onClick={() => handleNextStep()}
      className={cn(
        'bg-white flex items-center gap-4  text-black font-bold text-xl p-4 cursor-pointer rounded-[10px] border-gray-30 border ',
        {
          'bg-[#e7e0ec]': isSelected
        }
      )}
    >
      <Box
        style={{ backgroundColor: iconContainerBackground }}
        className="flex justify-center p-2 w-10 h-10 rounded-full"
      >
        {icon === 'whiteBBLogo' && <BbLogoIcon />}
        {icon === 'whiteClip' && <AttachFileIcon sx={{ color: 'white', flexShrink: 0 }} />}
        {icon === 'user' && <PersonOutlineIcon sx={{ color: 'white', flexShrink: 0 }} />}
        {icon === 'verified' && <CheckIcon sx={{ color: 'white', flexShrink: 0 }} />}
        {icon === 'close' && <CloseIcon sx={{ color: 'white', flexShrink: 0 }} />}
        {icon === 'phone' && <MobileFriendlyOutlinedIcon sx={{ color: 'white', flexShrink: 0 }} />}
        {icon === 'pencil' && <ModeEditOutlinedIcon sx={{ color: 'white', flexShrink: 0 }} />}
      </Box>
      <Box className="gap-1">
        <Typography sx={{ ...useTextStyles.titleLarge }}>{title}</Typography>
        <Typography sx={{ ...useTextStyles.bodyMedium }}>{subtitle}</Typography>
      </Box>
    </Box>
  )
}

export default SimpleCard
